import React, { memo } from 'react';

import { Grid } from '@material-ui/core';
import { includes } from 'lodash';
import PropTypes from 'prop-types';

import { PLANOGRAM_VERSION_STATUS } from 'pages/planograms/constants';
import { StatusComponent } from 'pages/planograms/StatusComponent/StatusComponent';
import { TemplateTypes } from 'types';

function UnderConstructionComponent({ planogram, isTemplate }) {
  return (
    <Grid container>
      {isTemplate ? (
        <>
          {planogram.sphereTemplate && planogram.sphereTemplate.isDefault ?
            <StatusComponent status={TemplateTypes.DEFAULT_TEMPLATE} /> :
            <StatusComponent status={TemplateTypes.TEMPLATE} />
          }
        </>
      ) : (
        <>
          {includes(planogram.planogramVersionsStatuses, PLANOGRAM_VERSION_STATUS.generated) && (
            <StatusComponent status={PLANOGRAM_VERSION_STATUS.generated} />
          )}
          {includes(planogram.planogramVersionsStatuses, PLANOGRAM_VERSION_STATUS.draft) && (
            <StatusComponent status={PLANOGRAM_VERSION_STATUS.draft} />
          )}
        </>
      )}
    </Grid>
  );
}

UnderConstructionComponent.propTypes = {
  planogram: PropTypes.shape({
    planogramVersionsStatuses: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  isTemplate: PropTypes.bool,
};

export const UnderConstruction = memo(UnderConstructionComponent);
